import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import assessmentTestRoutes from "./assessmentTestRoutes";
import satRoutes from "./sat_routes";

const routes = [
  {
    path: "/",
    name: "landing",
    component: () => import("../components/Landing.vue"),
    // redirect: "/my-account",
  },
  {
    path: "/register-modal",
    name: "register-modal",
    component: () => import("../components/RegisterModal.vue"),
  },
  {
    path: "/collins",
    name: "collins",
    component: () => import("../components/Collins.vue"),
    meta: { is_protected: true },
  },
  {
    path: "/noodle-factory",
    name: "noodle-factory",
    component: () => import("../components/NoodleFactory.vue"),
    meta: { is_protected: true },
  },
  {
    path: "/why-eody",
    name: "whyeody",
    component: () => import("../components/landing/why-eody/index.vue"),
    children: [
      {
        path: "videos",
        component: () => import("../components/landing/why-eody/Videos.vue"),
        name: "whyeody.videos",
      },
      {
        path: "practice",
        component: () => import("../components/landing/why-eody/Practice.vue"),
        name: "whyeody.practice",
      },
      {
        path: "tests",
        component: () => import("../components/landing/why-eody/Tests.vue"),
        name: "whyeody.tests",
      },
      {
        path: "doubts",
        component: () => import("../components/landing/why-eody/Doubts.vue"),
        name: "whyeody.doubts",
      },
    ],
  },
  {
    path: "/curriculum",
    name: "landing.curriculum",
    component: () => import("../components/landing/curriculum/index.vue"),
    children: [
      {
        path: "subjects",
        name: "landing.subjects",
        // subjects will list the courses
        component: () => import("../components/landing/curriculum/Courses.vue"),
      },
      {
        path: "courses/:id",
        name: "landing.courses",
        // courses will list the topics
        component: () => import("../components/landing/curriculum/Topics.vue"),
      },
      {
        path: "topics/:id",
        name: "landing.topics",
        // topics will list the subtopics
        component: () => import("../components/landing/curriculum/Subtopics.vue"),
      },
    ],
  },
  {
    path: "/edit-profile",
    name: "edit-profile",
    component: () => import("../components/EditProfile.vue"),
    meta: { is_protected: true },
  },
  {
    path: "/my-account",
    name: "my-account",
    component: () => import("../components/MyAccount.vue"),
    meta: { is_protected: true },
  },
  {
    path: "/admin-panel",
    name: "admin-panel",
    component: () => import("../components/AdminPanel.vue"),
    meta: { is_protected: true },
  },
  {
    path: "/aptitude-test",
    name: "aptitude-test",
    component: () => import("../components/AptitudeTest.vue"),
    meta: { is_protected: true },
  },
  {
    path: "/notifications",
    name: "notifications",
    component: () => import("../components/Notifications.vue"),
    meta: { is_protected: true },
  },
  {
    path: "/tickets",
    name: "ticket",
    component: () => import("../components/ticket/Ticket.vue"),
    meta: { is_protected: true },
    children: [
      {
        path: "/",
        name: "ticket.all",
        component: () => import("../components/ticket/TicketList.vue"),
        meta: { is_protected: true },
      },
      {
        path: "create",
        name: "ticket.create",
        component: () => import("../components/ticket/TicketCreate.vue"),
        meta: { is_protected: true },
      },
      {
        path: ":id",
        name: "ticket.details",
        component: () => import("../components/ticket/TicketDetails.vue"),
        meta: { is_protected: true },
      },
    ],
  },
  // {
  //     path: "/my-subjects",
  //     name: "my-subjects",
  //     component: () => import("../components/MyCourses.vue"),
  // },
  {
    path: "/auditor-course",
    name: "CourseBase",
    component: () => import("../components/auditor/course/CourseBase.vue"),
    children: [
      {
        path: ":grade/subjects",
        component: () => import("../components/auditor/course/CourseBase.vue"),
        name: "subjects",
        meta: { is_protected: true },
      },
      {
        path: ":grade/:subject/courses",
        component: () => import("../components/auditor/course/CourseBase.vue"),
        name: "courses",
        meta: { is_protected: true },
      },
      {
        path: "/course/:course/topic/:topic",
        component: () => import("../components/auditor/course/CourseBase.vue"),
        name: "course.topic.sub-topic",
        meta: { is_protected: true },
      },
      {
        path: "/sub-topic/:subTopic",
        component: () => import("../components/auditor/course/CourseBase.vue"),
        name: "course.sub-topic.start",
        meta: { is_protected: true },
      },
    ],
    meta: { is_protected: true },
  },
  {
    path: "/my-topics",
    name: "my-topics",
    component: () => import("../components/MyTopics.vue"),
    children: [
      {
        path: "create",
        component: () => import("../components/MyTopics.vue"),
        name: "topic.create",
        meta: { is_protected: true },
      },
    ],
    meta: { is_protected: true },
  },
  /*  {
    path: '/my-teachers',
    name: 'my-teachers',
    component: () => import('../components/MyTeachers.vue'),
    meta: { is_protected: true }
  }, */
  {
    path: "/import",
    name: "import",
    component: () => import("../components/import/Import.vue"),
    meta: { is_protected: true },
  },
  {
    path: "/backup",
    name: "backup",
    component: () => import("../components/backup/Backup.vue"),
    meta: { is_protected: true },
  },
  {
    path: "/student-progress",
    name: "student-progress",
    component: () => import("../components/Reports/StudentProgressPage.vue"),
    meta: { is_protected: true },
  },
  {
    path: "/assessment-report",
    name: "assessment-report",
    component: () => import("../components/Reports/AssessmentReportPage.vue"),
    meta: { is_protected: true },
  },
  {
    path: "/my-reports",
    name: "my-reports",
    component: () => import("../components/Reports/MyReports.vue"),
    meta: { is_protected: true },
    children: [
      {
        path: "",
        name: "reports.summary",
        component: () => import("../components/Reports/summary-report/SummaryReport.vue"),
        meta: { is_protected: true },
      },
      {
        path: "progress-report",
        name: "reports.progress",
        component: () => import("../components/Reports/progress-report/ProgressReport.vue"),
        meta: { is_protected: true },
      },
      {
        path: "activity-report",
        name: "reports.activity",
        component: () => import("../components/Reports/activity-report/ActivityReport.vue"),
        meta: { is_protected: true },
      },
      {
        path: "pre-assessment-report",
        name: "reports.pre-assessment",
        component: () => import("../components/Reports/assessment-report/AssessmentReport.vue"),
        meta: { is_protected: true },
      },
      {
        path: "post-assessment-report",
        name: "reports.post-assessment",
        component: () => import("../components/Reports/assessment-report/AssessmentReport.vue"),
        meta: { is_protected: true },
      },
      {
        path: "compare",
        name: "reports.compare-pre-post",
        component: () => import("../components/Reports/compare/ComparePrePost.vue"),
        meta: { is_protected: true },
      },
      {
        path: "gap-report",
        name: "reports.gap",
        component: () => import("../components/Reports/gap-report/GapReport.vue"),
        meta: { is_protected: true },
        children: [
          {
            path: ":subjectSlug/reading-tests",
            name: "reports.gap.reading.tests",
            component: () =>
              import(
                "../components/Reports/gap-report/StudentGapReportIncludes/GapReportTopicList.vue"
              ),
            meta: { is_protected: true },
            children: [
              {
                path: "pre",
                name: "reports.gap.reading.tests.pre",
                component: () =>
                  import(
                    "../components/Reports/gap-report/StudentGapReportIncludes/ReadingTestDetails.vue"
                  ),
                meta: { is_protected: true },
              },
              {
                path: "post",
                name: "reports.gap.reading.tests.post",
                component: () =>
                  import(
                    "../components/Reports/gap-report/StudentGapReportIncludes/ReadingTestDetails.vue"
                  ),
                meta: { is_protected: true },
              },
            ],
          },
        ],
      },
      {
        path: "intellectual-report",
        name: "reports.intellectual",
        component: () => import("../components/Reports/intellectual-report/IntellectualReport.vue"),
        meta: { is_protected: true },
      },
    ],
  },
  {
    path: "/notices",
    name: "notices",
    component: () => import("../components/Notices.vue"),
    meta: { is_protected: true },
  },

  {
    path: "/assessment",
    name: "assessment",
    component: () => import("../components/Assessments.vue"),
    children: [
      {
        path: "index",
        component: () => import("../components/Assessments.vue"),
        name: "assessment.index",
        meta: { is_protected: true },
      },
      {
        path: "create",
        component: () => import("../components/Assessments.vue"),
        name: "assessment.create",
        meta: { is_protected: true },
      },
    ],
    meta: { is_protected: true },
  },
  {
    path: "/page-1",
    name: "page-1",
    component: () => import("../components/Page1.vue"),
  },
  {
    path: "/page-2",
    name: "page-2",
    component: () => import("../components/Page2.vue"),
  },
  {
    path: "/page-3",
    name: "page-3",
    component: () => import("../components/Page3.vue"),
  },
  {
    path: "/page-4",
    name: "page-4",
    component: () => import("../components/Page4.vue"),
  },
  {
    path: "*",
    name: "404",
    component: () => import("../components/404.vue"),
  },
  {
    path: "/notices",
    name: "notice",
    component: () => import("../components/notice/Index.vue"),
    children: [
      {
        path: "all",
        component: () => import("../components/notice/AllNotices.vue"),
        name: "notice.all",
      },
      {
        path: "create",
        component: () => import("../components/notice/CreateNotice.vue"),
        name: "notice.create",
      },
    ],
  },
  {
    path: "/teachers",
    name: "teachers",
    component: () => import("../components/MyTeachers.vue"),
    children: [
      {
        path: "create",
        component: () => import("../components/MyTeachers.vue"),
        name: "teachers.create",
      },
      {
        path: "edit/:teacherId",
        component: () => import("../components/MyTeachers.vue"),
        name: "teachers.edit",
      },
    ],
  },
  {
    path: "/hod",
    name: "hods.index",
    component: () => import("../components/MyHod.vue"),
    children: [
      {
        path: "create",
        component: () => import("../components/MyHod.vue"),
        name: "hods.create",
      },
      {
        path: "edit/:hodId",
        component: () => import("../components/MyHod.vue"),
        name: "hods.edit",
      },
    ],
  },
  {
    path: "/auditor",
    name: "auditor.index",
    component: () => import("../components/MyAuditor.vue"),
    children: [
      {
        path: "create",
        component: () => import("../components/MyAuditor.vue"),
        name: "auditor.create",
      },
      {
        path: "edit/:auditorId",
        component: () => import("../components/MyAuditor.vue"),
        name: "auditor.edit",
      },
    ],
  },
  {
    path: "/students",
    name: "students",
    component: () => import("../components/MyStudents.vue"),
    children: [
      {
        path: "create",
        component: () => import("../components/MyStudents.vue"),
        name: "students.create",
      },
      {
        path: "edit/:studentId",
        component: () => import("../components/MyStudents.vue"),
        name: "students.edit",
      },
      {
        path: "upgrade",
        component: () => import("../components/MyStudents.vue"),
        name: "students.upgrade",
      },
    ],
  },
  {
    path: "/parents",
    name: "parents",
    component: () => import("../components/MyParents.vue"),
  },
  // {
  //     path: "/import",
  //     name: "import",
  //     component: () => import("../components/Import.vue"),
  // },
  {
    path: "/setting",
    name: "setting",
    component: () => import("../components/Setting.vue"),
  },
  {
    path: "/my-files",
    name: "my-files",
    component: () => import("../components/Files/MyFiles.vue"),
  },
  {
    path: "/emails",
    name: "emaillist",
    component: () => import("../components/EmailList.vue"),
  },
  {
    path: "/emails/send",
    name: "email-send",
    component: () => import("../components/EmailSend.vue"),
  },
  {
    path: "/emails/view/:id",
    name: "email",
    component: () => import("../components/Email.vue"),
  },

  {
    path: "/draft/view/:id",
    name: "email-draft",
    component: () => import("../components/Draft.vue"),
  },

  {
    path: "/forgot/password",
    name: "forgot-password",
    component: () => import("../components/ForgotPassword.vue"),
  },

  {
    path: "/change/password",
    name: "change-password",
    component: () => import("../components/ChangePassword.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../components/auth/RegisterSchoolPicker.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../components/auth/LoginSchoolPicker.vue"),
  },
  {
    path: "/oauth",
    name: "oauth",
    component: () => import("../components/auth/OAuth.vue"),
  },
  {
    path: "/sketch",
    name: "sketch",
    component: () => import("../components/dashboard/sketch/sketch"),
  },
  {
    path: "/:schoolCode/register",
    name: "register_with_school",
    component: () => import("../components/auth/Register.vue"),
  },
  {
    path: "/:schoolCode/login",
    name: "login_with_school",
    component: () => import("../components/auth/Login.vue"),
  },
  ...assessmentTestRoutes(),
  ...satRoutes,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.is_protected) {
    var user = window.localStorage.getItem("user");
    if (user) {
      next();
    } else {
      next({ name: "login" });
    }
  } else {
    next();
  }
});
export default router;
